import {ACTION_TYPES} from "../../../../../core/consts";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {APP} from "../../../../../core/app/consts";
import {override} from "mobx";
import {GameCenterTabModel} from "./game-center.tab-model";

export class GameCenterH2hTabModel extends GameCenterTabModel {
  @override get isVisible(): Boolean {
    return this.entity.previousMeetings?.length > 0 || this.entity.homeCompetitor.recentMatches?.length > 0 || this.entity.awayCompetitor.recentMatches?.length > 0;
  }

  get eventName(): String {
    return ACTION_TYPES.h2hClick
  }

  get eventParams(): Object {
    const eventParams = {
      gameId: this.entity.id,
      entityId: this.entity.id,
      status: this.entity.statusGroup,
      source: APP.ANALYTICS.SOURCES.gameCenterTabs,
    }

    return eventParams;
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.h2h;
  }

  get elementId(): String {
    return 'navigation-tabs_game-center_h2h';
  }
}
